import React from 'react';

import MasterLayout from '../../masterLayout/MasterLayout';
import Breadcrumb from '../../components/Breadcrumb';
import TermsAndConditionsList from './TermsAndConditionsList';

const TermsAndConditionsPage = () => {
  return (
    <>
      <MasterLayout>
        <Breadcrumb title="Terms and Conditions" />
        <TermsAndConditionsList />
      </MasterLayout>
    </>
  );
};

export default TermsAndConditionsPage;
